/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const UserAddedIcon = createIcon(
  '0 0 20 20',
  <path d="M5.08 6c0-2.21 1.828-4 4.082-4s4.08 1.79 4.08 4c0 2.034-1.549 3.714-3.554 3.967a.02.02 0 0 0-.016.018q.002.016.018.019a7.23 7.23 0 0 1 3.89 1.281c-1.98.688-3.398 2.539-3.398 4.715a4.9 4.9 0 0 0 .424 2H1l1.093-3.214c.947-2.785 3.563-4.687 6.54-4.782a.02.02 0 0 0 .019-.019.02.02 0 0 0-.017-.018C6.63 9.714 5.081 8.034 5.081 6M20 13.22 15.282 19l-3.681-2.883 1.273-1.562 2.089 1.635 3.444-4.22z" />,
);
